import { render } from "./indicator.vue?vue&type=template&id=23da5944"
import script from "./indicator.vue?vue&type=script&lang=js"
export * from "./indicator.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260131003634/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__